package app.nestbridge.feature.careteam.api.model

import kotlinx.serialization.Serializable

@Serializable
data class CareTeamMemberDto(
    val userId: String,
    val role: TeamRelationshipRoleDto,
)
